import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import {
  VideoBlock,
  VideoListComponent,
} from '@domgen/dgx-fe-components/media';
import { YoutubePlayerModule } from './video-player/youtube-player.module';
import {
  ContentComponent,
  RichTextComponent,
} from '@domgen/dgx-fe-components/content';
import {
  LinkComponent,
  NavigationLinkDirective,
} from '@domgen/dgx-fe-components/navigation';
import {
  ButtonLinkComponent,
  ButtonTextComponent,
} from '@domgen/dgx-fe-components/button';
import { NavigationLink } from '@domgen/dgx-fe-common';
import { SmartFixHubAnalyticsService } from 'libs/self-fix/data-access/src/lib/services/sf-hub-analytics/sf-hub-analytics-service';

@Component({
  selector: 'dgx-components-video-list-block',
  templateUrl: './video-list-block.component.html',
  styleUrls: ['./video-list-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContentComponent,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    VideoListComponent,
    RichTextComponent,
    CommonModule,
    YoutubePlayerModule,
    NavigationLinkDirective,
    ButtonTextComponent,
  ],
  standalone: true,
})
export class VideoListBlockComponent {
  @Input() body?: string;
  @Input() description?: string;
  @Input() hideControlPanel?: boolean;
  @Input() hideFullScreen?: boolean;
  @Input() autoPlay?: boolean;
  @Input() title?: string;
  @Input() videos: VideoBlock[] = [];
  @Input() navLink?: NavigationLink;

  constructor(private smartFixAnalytics: SmartFixHubAnalyticsService) {}

  onClick(navigation: HTMLAnchorElement, video: VideoBlock) {
    this.sendAnalytics(video);
    window.location.href = navigation.href;
  }

  sendAnalytics(video: VideoBlock) {
    this.smartFixAnalytics.trackEvent({
      event: 'genericGAEvent',
      category: 'my-account-dgx',
      eventCategory: 'sf-hub',
      eventAction: 'video watched',
      eventLabel: 'video play - ' + video.title,
      pagename: 'claims-sf-hub-dashboard',
    } as any);
  }
}
